import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
}
export function FadeIn({
  children,
  delay = 0,
  direction = 'up',
  className = ''
}: FadeInProps) {
  const shouldReduceMotion = useReducedMotion();
  const directionOffset = {
    up: {
      y: 40,
      x: 0
    },
    down: {
      y: -40,
      x: 0
    },
    left: {
      x: 40,
      y: 0
    },
    right: {
      x: -40,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  const offset = shouldReduceMotion ? {
    x: 0,
    y: 0
  } : directionOffset[direction];
  return <motion.div initial={{
    opacity: 0,
    ...offset
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: shouldReduceMotion ? 0.2 : 0.6,
    delay: shouldReduceMotion ? 0 : delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-61" data-mp="3o1rqrq7o0qsz">
      {children}
    </motion.div>;
}